/* eslint-disable max-len */
export default function SubItemController(
  $q,
  $rootScope,
  $scope,
  alerts,
  oversightDataService,
  oversightSharedModelService,
  markAgendaItemCompleteConfirmDialog,
  editAgendaItemDialog,
  addAgendaItemNoteDialog,
  attachAgendaItemDialog,
  confirmDialog,
  docDataService,
  serviceIds,
  loaderService,
  orgDataService,
  ssDialogService,
) {
  const vm = this;

  // Set Default Values
  vm.serviceId = serviceIds.oversight;
  vm.canExpand = true;
  vm.isExpanded = false;
  vm.canEditItem = vm.canEdit && (!vm.item.agendaSubItems || vm.item.agendaSubItems.length === 0);
  vm.canDeleteItem = vm.canDelete && (!vm.item.agendaSubItems || vm.item.agendaSubItems.length === 0);

  vm.canAddItemNote = vm.agendaIsActive && (!vm.item.agendaSubItems || vm.item.agendaSubItems.length === 0);
  vm.canAttachItemItems = vm.agendaIsActive && (!vm.item.agendaSubItems || vm.item.agendaSubItems.length === 0);

  // Attach Event Handlers
  vm.handleExpandAgendaItem = _handleExpandAgendaItem;
  vm.handleEditAgendaItem = _handleEditAgendaItem;
  vm.handleAddNote = _handleAddAgendaItemNote;
  vm.handleMarkStatusComplete = _handleMarkStatusComplete;
  vm.handleAttachItems = _handleAttachItems;
  vm.documentAttached = _documentAttached;
  vm.handleCancelComplete = _handleCancelComplete;
  vm.handleMarkAgendaItemChecked = _handleMarkAgendaItemChecked;

  _activate();

  /** **********************************************
   * Event Handlers
   */

  function _handleExpandAgendaItem() {
    vm.isExpanded = !vm.isExpanded;
  }

  function _handleAddAgendaItemNote($event) {
    ssDialogService.dialogs.oversight.addAgendaItemNoteDialog = ssDialogService.alert(
      addAgendaItemNoteDialog.getOptions($event, {
        agendaItemId: vm.item.agendaItemId,
        agendaItemCommentId: -1,
        agendaItemCommentText: '',
        agendaItemFollowupId: -1,
        agendaItemFollowText: '',
        refreshAgendaItem: true
      })
    );
    ssDialogService.show(ssDialogService.dialogs.oversight.addAgendaItemNoteDialog);
  }

  function _handleAttachItems($event) {
    loaderService.showViewLoader = true;
    docDataService.getFolderProperties(-1).then((getFolderResponse) => {
      vm.rootFolder = getFolderResponse.data;

      ssDialogService.dialogs.oversight.attachAgendaItemDocumentDialog = ssDialogService.alert(
        attachAgendaItemDialog.getOptions($event, {
          serviceId: vm.serviceId,
          agendaItemId: vm.item.agendaItemId,
          folder: vm.rootFolder,
          attachCallback: vm.documentAttached,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.oversight.attachAgendaItemDocumentDialog);
    });
  }

  function _documentAttached() {
    $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.item.agendaItemId });
  }

  function _handleEditAgendaItem($event) {
    const locals = {
      item: vm.item, refreshAgendaItem: false, canSave: true, users: vm.users
    };
    ssDialogService.dialogs.oversight.editAgendaItemDialog = ssDialogService.alert(
      editAgendaItemDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.oversight.editAgendaItemDialog);
  }

  function _handleMarkAgendaItemChecked() {
    loaderService.showViewLoader = true;
    oversightDataService.markAgendaItemChecked(vm.item.agendaItemId).then(() => {
      alerts.success('The Agenda item has been successfully checked. ');
      loaderService.showViewLoader = true;
      $rootScope.$broadcast('refreshUpdateAgendaSubItem', { agendaItemId: vm.item.agendaItemId });
    });
  }

  /** **********************************************
   * Private Functions
   */

  function _activate() {
    const dfdActivate = $q.defer();

    _refreshUsers().then(
      dfdActivate.resolve,
    );

    _initEventListeners();
    resetStatus();
  }

  function _initEventListeners() {
    $scope.$on('refreshAgendaItem', (event, opt) => {
      if (opt.agendaItemId === vm.item.agendaItemId) {
        refreshAgendaItem();
      }
    });
    $scope.$on('refreshUpdateAgendaSubItem', (event, opt) => {
      if (opt.agendaItemId === vm.item.agendaItemId) {
        refreshAgendaItem();
      }
    });
  }

  function refreshAgendaItem() {
    loaderService.showViewLoader = true;
    return oversightDataService.getAgendaItem(vm.item.agendaItemId)
      .then((response) => {
        loaderService.showViewLoader = false;
        vm.item = response.data;
        resetStatus();
      });
  }

  // /////////////// Complete /////////////////

  function _handleMarkStatusComplete($event) {
    const locals = {
      item: vm.item, refreshAgendaItem: true, canSave: true, users: vm.users
    };
    ssDialogService.dialogs.oversight.markAgendaItemCompleteConfirmDialog = ssDialogService.alert(
      markAgendaItemCompleteConfirmDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.oversight.markAgendaItemCompleteConfirmDialog);
  }

  function _handleCancelComplete() {
    _closeCompleteDialog();
  }

  function _closeCompleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.oversight.markAgendaItemCompleteConfirmDialog);
  }

  function _refreshUsers() {
    const dfdRefresh = $q.defer();

    vm.users = oversightSharedModelService.applicationUsers;
    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }

  function resetStatus() {
    vm.canChangeItemStatus = vm.agendaIsActive && vm.canChangeStatus && (!vm.item.agendaSubItems || vm.item.agendaSubItems.length === 0)
      && vm.item.agendaItemStatusId !== 3;
  }
}

SubItemController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'oversightDataService',
  'oversightSharedModelService',
  'markAgendaItemCompleteConfirmDialog',
  'editAgendaItemDialog',
  'addAgendaItemNoteDialog',
  'attachAgendaItemDialog',
  'confirmDialog',
  'docDataService',
  'serviceIds',
  'loaderService',
  'orgDataService',
  'ssDialogService',
];
